"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _socket = _interopRequireDefault(require("socket.io-client"));

var _config = _interopRequireWildcard(require("../utils/config"));

var _tokenHandler = _interopRequireDefault(require("./tokenHandler"));

var _logsHandler = _interopRequireDefault(require("./logsHandler"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const connect = ({
  accountId: accountIdParam,
  debug = false,
  env,
  JWT,
  logger,
  url,
  authenticated = true,
  authId,
  client
}) => new Promise((resolve, reject) => {
  var _tokenHandler$decode;

  const debugMsg = msg => {
    if (debug) console.log('NeatSocket-Client', msg);
  };

  const accountId = ((_tokenHandler$decode = _tokenHandler.default.decode(JWT)) === null || _tokenHandler$decode === void 0 ? void 0 : _tokenHandler$decode.accountId) || accountIdParam;
  const socketURL = url || (env ? (0, _config.getConfigByEnv)(env).SOCKET_URL : _config.default.SOCKET_URL);

  const socket = _socket.default.connect(socketURL, {
    auth: {
      token: JWT
    },
    query: _objectSpread(_objectSpread(_objectSpread({}, accountId ? {
      accountId
    } : {}), {}, {
      authenticated
    }, authenticated ? {} : {
      authId
    }), client ? {
      client
    } : {}),
    transports: ['websocket']
  });

  socket.on('error', error => {
    debugMsg({
      event: 'error',
      data: error,
      authenticated,
      authId,
      accountId,
      client
    });
    reject(Error(error));
  });
  socket.on('connect_error', error => {
    debugMsg({
      event: 'connect error',
      data: error,
      authenticated,
      authId,
      accountId,
      client
    });

    if (process.env.NODE_ENV === 'test') {
      // prevents the following error: Jest has detected the following 1 open handle potentially keeping Jest from exiting: ●  TCPWRAP
      // According to socket.io docs, there is actually no connection established when 'connect_error' happens, so doesn't seem like we
      // should be calling disconnect in a non test environment?
      socket.disconnect();
    }

    reject(error);
  });
  socket.on('connect', () => {
    debugMsg({
      event: 'connected',
      authenticated,
      accountId,
      authId,
      data: {
        server: socketURL
      },
      client
    });
    resolve(socket);
  });
  socket.on('disconnect', reason => {
    debugMsg({
      event: 'disconnect',
      data: reason,
      authenticated,
      accountId,
      authId,
      client
    });

    if (reason !== 'io server disconnect' && reason !== 'io client disconnect') {
      _logsHandler.default.error(`${reason} - ${authenticated ? 'account' : 'authId'} ${authenticated ? accountId : authId}`);

      if (logger) logger(reason);
    }
  });
  socket.onAny((event, ...data) => {
    debugMsg({
      event,
      data
    });
  });
});

var _default = {
  connect
};
exports.default = _default;
//# sourceMappingURL=connectionHandler.js.map